"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeleswapScripts = void 0;
const providers_1 = require("@teleportdao/providers");
const bitcoin_1 = require("@teleportdao/bitcoin");
const feeUtils = __importStar(require("./scripts/fee-utils"));
const helper_1 = require("./utils/helper");
class TeleswapScripts {
    constructor(targetNetworkConnection, sourceNetworkConnection = {
        utxo: {
            provider: "MempoolSpace",
        },
    }, staticLockerAddresses) {
        this.targetNetworkConnection = targetNetworkConnection;
        this.isTestnet = targetNetworkConnection.networkName.includes("_testnet");
        this.teleportdao = new providers_1.TeleportDao(this.isTestnet);
        this.networkName = targetNetworkConnection.networkName;
        const { connectionConfig } = (0, helper_1.getWeb3Eth)(targetNetworkConnection);
        this.targetNetworkConnectionConfig = Object.assign(Object.assign({}, connectionConfig), { networkName: targetNetworkConnection.networkName });
        this.staticLockerAddresses = staticLockerAddresses;
        this.sourceNetworkConnection = sourceNetworkConnection;
        this.bitcoinWallet = new bitcoin_1.BitcoinBaseWallet(this.isTestnet ? "bitcoin_testnet" : "bitcoin", sourceNetworkConnection);
    }
    static getWeb3Eth(targetNetworkConnectionInfo) {
        return (0, helper_1.getWeb3Eth)(targetNetworkConnectionInfo);
    }
    estimateWrapTransactionFee(utxo, feeRate, type = "WrapAndSwap") {
        const usableUtxo = utxo.filter((u) => (bitcoin_1.componentBytes.bytePerInput[u.signerInfo.addressType] || bitcoin_1.componentBytes.bytePerInput.default) *
            +feeRate <
            u.value);
        const txSize = this.bitcoinWallet.transactionBuilder.calculateTxSize(usableUtxo.map((u) => u.signerInfo.addressType), []);
        const scriptSize = type === "Wrap" ? 31 : 70;
        const changeFee = bitcoin_1.componentBytes.bytePerOutput.max * feeRate;
        const noChangeFee = (txSize +
            bitcoin_1.componentBytes.bytePerOutput.p2sh +
            bitcoin_1.componentBytes.scriptExtraBytes.moreThan255 +
            scriptSize +
            bitcoin_1.componentBytes.bytePerOutput.max) *
            feeRate;
        return {
            noChangeFee: noChangeFee.toFixed(),
            fee: (changeFee + noChangeFee).toFixed(),
        };
    }
    getLockerAddresses() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.staticLockerAddresses) {
                return this.staticLockerAddresses;
            }
            let lockers = yield this.teleportdao.getLockers(this.networkName.replace("_testnet", ""));
            return lockers.map((l) => ({
                targetAddress: l.targetAddress,
                sourceAddress: l.sourceAddress,
            }));
        });
    }
    getThirdPartFee(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return feeUtils.getThirdPartyFee(id, this.targetNetworkConnectionConfig);
        });
    }
    getAllFeeParams() {
        return __awaiter(this, void 0, void 0, function* () {
            return feeUtils.getFeeParams(this.targetNetworkConnectionConfig);
        });
    }
    getWrapFeeParams(type) {
        return __awaiter(this, void 0, void 0, function* () {
            return feeUtils.getWrapFeeParams(type, this.targetNetworkConnectionConfig);
        });
    }
    getUnwrapFeeParams() {
        return __awaiter(this, void 0, void 0, function* () {
            return feeUtils.getUnwrapFeeParams(this.targetNetworkConnectionConfig);
        });
    }
    calculateWrapFee(amountBTC, type, nativeTokenBTCRate, isReceivedAmount = false, thirdPartyPercentageFee = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = yield this.getWrapFeeParams(type);
            return feeUtils.calculateWrapFee(amountBTC, Object.assign(Object.assign({ thirdPartyPercentageFee }, feeInfo), { nativeTokenBTCRate }), isReceivedAmount);
        });
    }
    calculateUnwrapFee(amountBTC, isReceivedAmount = false, thirdPartyPercentageFee = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = yield this.getUnwrapFeeParams();
            return feeUtils.calculateUnwrapFee(amountBTC, Object.assign({ thirdPartyPercentageFee }, feeInfo), isReceivedAmount);
        });
    }
    calculateWrapFeeBackend(amountBTC, type, isReceivedAmount = false, thirdPartyPercentageFee = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = yield this.teleportdao.getAllFeeParams(this.targetNetworkConnection.networkName.replace("_testnet", ""));
            const { nativeTokenBTCRate } = feeInfo;
            const wrapFeeInfo = Object.assign(Object.assign({}, feeUtils.extractWrapFeeFromAllFee(type, feeInfo, thirdPartyPercentageFee)), { nativeTokenBTCRate });
            const minAmount = feeUtils.getMinWrapAmount(wrapFeeInfo);
            return Object.assign(Object.assign({}, feeUtils.calculateWrapFee(amountBTC, wrapFeeInfo, isReceivedAmount)), { minAmount });
        });
    }
    calculateUnwrapFeeBackend(amountBTC, isReceivedAmount = false, thirdPartyPercentageFee = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = yield this.teleportdao.getAllFeeParams(this.targetNetworkConnection.networkName.replace("_testnet", ""));
            const minAmount = feeUtils.getMinUnwrapAmount(feeUtils.extractUnwrapFeeFromAllFee(feeInfo, thirdPartyPercentageFee));
            return Object.assign(Object.assign({}, feeUtils.calculateUnwrapFee(amountBTC, feeUtils.extractUnwrapFeeFromAllFee(feeInfo, thirdPartyPercentageFee), isReceivedAmount)), { minAmount });
        });
    }
    getMinWrapFeeBackend(type, thirdPartyPercentageFee = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = yield this.teleportdao.getAllFeeParams(this.targetNetworkConnection.networkName.replace("_testnet", ""));
            const { nativeTokenBTCRate } = feeInfo;
            const wrapFeeInfo = Object.assign(Object.assign({}, feeUtils.extractWrapFeeFromAllFee(type, feeInfo, thirdPartyPercentageFee)), { nativeTokenBTCRate });
            const minAmount = feeUtils.getMinWrapAmount(wrapFeeInfo);
            return minAmount;
        });
    }
    getMinUnwrapFeeBackend(thirdPartyPercentageFee = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = yield this.teleportdao.getAllFeeParams(this.targetNetworkConnection.networkName.replace("_testnet", ""));
            const minAmount = feeUtils.getMinUnwrapAmount(feeUtils.extractUnwrapFeeFromAllFee(feeInfo, thirdPartyPercentageFee));
            return minAmount;
        });
    }
}
exports.TeleswapScripts = TeleswapScripts;
exports.default = TeleswapScripts;
//# sourceMappingURL=teleswap-scripts.js.map